import React from 'react';
import Header from '../components/landing/Header';
import HeroSection from '../components/landing/HeroSection';
import VideoDemo from '../components/landing/VideoDemo';
import WorkflowSection from '../components/landing/WorkflowSection';
import ProspectingWorkflow from '../components/landing/ProspectingWorkflow';
import MarketingWorkflow from '../components/landing/MarketingWorkflow';
import FeaturesGrid from '../components/landing/FeaturesGrid';
import AppShowcase from '../components/landing/AppShowcase';
import TestimonialsSection from '../components/landing/TestimonialsSection';
import ConciergeCTA from '../components/landing/ConciergeCTA';
import FAQSection from '../components/landing/FAQSection';
import Footer from '../components/landing/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-[#000000]">
      <Header />
      <main>
        <HeroSection />
        <VideoDemo />
        
        {/* Distribution Workflow (Existing) */}
        <WorkflowSection />

        {/* Marketing & Discovery Workflows (New) */}
        <ProspectingWorkflow />
        <MarketingWorkflow />

        <FeaturesGrid />
        <AppShowcase />
        <TestimonialsSection />
        <FAQSection />
        <ConciergeCTA />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;